import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import firebase from '../helpers/firebase';
import Loader from 'halogen/RingLoader';
import { TABLE_NAME } from '../helpers/constants';

const db = firebase.database();

class UserCombobox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
    this.getUsers = this.getUsers.bind(this);
    this.updateSelectedUser = this.updateSelectedUser.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers() {
    db.ref(TABLE_NAME.USERS).once('value').then((snapshot) => {
      const users = [];

      const data = snapshot.val()
      const keys = Object.keys(data)
      keys.forEach(key => {
        const u = Object.assign({id: key}, data[key]);
        users.push(u);
      })

      const selectedUserId = this.state.selectedUserId || users[0].id;
      this.setState({
        users: users,
        selectedUserId
      }, this.updateSelectedUser);
    });
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value
    }, this.updateSelectedUser);
  }

  updateSelectedUser() {
    this.props.onInputChange && this.props.onInputChange(
      this.state.selectedUserId
    );
  }

  render() {
    if (this.state.users.length === 0) {
      return (
        <div className="loader-wrapper" style={{height: '198px'}}>
          <Loader color="#26194b" size="60px" className="loader-small" />
        </div>
      )
    }

    const users = this.state.users.map((u) => {
      return (<option key={u.id} value={u.id}>{u.name}</option>)
    });

    return (
      <FormGroup controlId="user">
        <ControlLabel>
          { this.props.title
            ? (this.props.title)
            : ("User Name")
          }
        </ControlLabel>
        <FormControl id="user"
          name="selectedUserId"
          onChange={this.handleInputChange}
          value={this.state.selectedUserId}
          componentClass="select"
          placeholder="select">
          {users}
        </FormControl>
        <HelpBlock>
          { this.props.description
            ? (this.props.description)
            : ("Pick a user you wish to add Timeoff")
          }
        </HelpBlock>
      </FormGroup>
    )
  }
}

export default UserCombobox



// WEBPACK FOOTER //
// ./src/components/UserCombobox.js